<template>
  <el-dialog append-to-body :title="title" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" :rules="rules" :model="formdata" label-width="120px">
        <el-form-item label="规格名称:" prop="name">
          <el-input v-model="formdata.name" class="w340"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import api from "@/api.js";
export default {
  name: "goodsSpecificationDialog",
  props: ["visible", "id"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      title: "新增规格",
      formdata: {
        name: ""
      },
      tableData: [],
      del_spec: [],
      del_item: [],
      lock: true,
      rules: {
        name: [{ required: true, message: "请输入规格名称", trigger: "blur" }]
      }
    };
  },
  created() {
    if (this.id) {
      this.title = "编辑规格";
      this.queryspecification();
    }
  },
  methods: {
    // 查询类目详情
    queryspecification() {
      let params = {
        id: this.id
      };

      this.axios
        .post(api.make_spe_detail, params)
        .then(response => {
          if (response.data.code == 0) {
            this.formdata.cate_id = response.data.info.id;
            this.formdata.name = response.data.info.name;
            this.translatedata(response.data.list);
          } else {
          }
        })
        .catch(() => {});
    },
    // 转换规格数据
    translatedata(data) {
      if (data && data.length > 0) {
        data.forEach(item => {
          let cateitem = {
            id: item.id,
            attrname: item.name,
            attrvalue: item.attr || [],
            inputVisible: false,
            inputValue: ""
          };
          this.tableData.push(cateitem);
        });
      }
    },
    handleClose(row, tagid, index) {
      if (tagid) {
        this.disableddel(tagid, 2, () => {
          row.attrvalue.splice(index, 1);
          this.del_item.push(tagid);
        });
      } else {
        row.attrvalue.splice(index, 1);
      }
    },

    showInput(row) {
      row.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm(row) {
      let inputValue = row.inputValue;
      if (inputValue) {
        row.attrvalue.push({ name: inputValue });
      }
      row.inputVisible = false;
      row.inputValue = "";
    },
    // 添加行
    addrow() {
      this.tableData.push({
        attrname: "",
        attrvalue: [],
        inputVisible: false,
        inputValue: ""
      });
    },
    // 删除行
    delrow(row, index) {
      if (row.id) {
        this.disableddel(row.id, 1, () => {
          this.tableData.splice(index, 1);
          this.del_spec.push(row.id);
        });
      } else {
        this.tableData.splice(index, 1);
      }
    },
    // 是否可以删除
    disableddel(id, type, fn) {
      let params = {
        id: id,
        type: type
      };
      this.axios
        .post(api.goods_attr_delete_check, params)
        .then(response => {
          if (response.data.code == 0) {
            fn();
          } else {
          }
        })
        .catch(() => {});
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.lock) {
            this.lock = false;
            if (this.id) {
              this.submiteditsave();
            } else {
              this.submitsave();
            }
          }
        } else {
          return false;
        }
      });
    },
    // 获取规格规格项
    getattrlist() {
      let result = [];
      if (this.tableData && this.tableData.length > 0) {
        this.tableData.forEach(item => {
          let attritem = {
            attr_name: item.attrname,
            attr_value: this.translateattr(item.attrvalue)
          };
          if (item.id) {
            attritem.id = item.id;
          }
          result.push(attritem);
        });
      }
      return result;
    },
    // 转换规格项
    translateattr(attrlist) {
      let res = attrlist.map(attrvalue => {
        let attritem = {
          name: attrvalue.name
        };
        if (attrvalue.id !== undefined) {
          attritem.id = attrvalue.id;
        }
        return attritem;
      });
      return res;
    },
    // 提交保存
    submitsave() {
      let params = {
        name: this.formdata.name,
        // attr_list: this.getattrlist()
      };
      this.axios
        .post(api.make_spe_add, params)
        .then(response => {
          this.lock = true;
          if (response.data.code == 0) {
            this.dialogVisible = false;
            this.$emit("specificationsuccess");
          } else {
          }
        })
        .catch(response => {
          this.lock = true;
        });
    },
    // 提交保存
    submiteditsave() {
      let params = {
        id: this.formdata.cate_id,
        name: this.formdata.name,
        attr_list: this.getattrlist(),
        del_spec: this.del_spec,
        del_item: this.del_item
      };
      this.axios
        .post(api.make_spe_edit, params)
        .then(response => {
          this.lock = true;
          if (response.data.code == 0) {
            this.dialogVisible = false;
            this.$emit("specificationsuccess");
          } else {
          }
        })
        .catch(response => {
          this.lock = true;
        });
    }
  }
};
</script>

